import { TInterpolation } from './types';

/**
 * Different with `t` method in library like `i18next`.
 * It's just a function to resolve interpolation.
 *
 * @example
 *
 * t('Hi, my name is {{name}}', { name: 'SurveyCake' });
 */
export function t(word: string, interpolation: TInterpolation) {
  return Object.entries(interpolation).reduce(
    (prev, [key, value]) => prev.replace(`{{${key}}}`, `${value}`),
    word
  );
}
